// UI/Dropdown.js
import styled from 'styled-components';

export const Dropdown = styled.select`
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 270px;
`;